import { useState, useEffect, useCallback } from 'react'

import { toast } from 'react-toastify'
import { axiosInstance } from '../helpers/axios'
import { ProjectPlanResponse } from '../navigation/layouts/Lori/types'

export const useProjectPlan = () => {
    const [projectPlanList, setProjectPlanList] = useState<
        ProjectPlanResponse[]
    >([])
    const [projectPlan, setProjectPlan] = useState<ProjectPlanResponse | null>(
        null,
    )

    const getProjectPlanList = async (force_company: boolean = false) => {
        await axiosInstance
            .get('/chat/project_plan/', { params: { force_company } })
            .then((res) => {
                setProjectPlanList(res.data)
                const mostRecentProjectPlan = res.data.reduce(
                    (
                        latest: ProjectPlanResponse,
                        current: ProjectPlanResponse,
                    ) => {
                        return new Date(current.created_date) >
                            new Date(latest.created_date)
                            ? current
                            : latest
                    },
                    res.data[0],
                )
                setProjectPlan(mostRecentProjectPlan)
            })
    }

    const updateTask = async (taskId: number, completed: boolean) => {
        await axiosInstance
            .post('/chat/project_plan/update_task/', {
                task_id: taskId,
                completed,
            })
            .then((res) => {
                setProjectPlan((prevPlan) => {
                    if (!prevPlan) return null
                    return {
                        ...prevPlan,
                        tasks: prevPlan.tasks.map((task) =>
                            task.id === taskId ? { ...task, completed } : task,
                        ),
                    }
                })
            })
            .catch((err) => {
                toast.error('Error updating task')
            })
    }

    return {
        projectPlanList,
        projectPlan,
        updateTask,
        getProjectPlanList,
    }
}

export type ProjectPlanController = ReturnType<typeof useProjectPlan>
